import { render, staticRenderFns } from "./SimplePaginator.vue?vue&type=template&id=580fc7d3&scoped=true&lang=pug"
import script from "./SimplePaginator.vue?vue&type=script&lang=js"
export * from "./SimplePaginator.vue?vue&type=script&lang=js"
import style0 from "./SimplePaginator.vue?vue&type=style&index=0&id=580fc7d3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580fc7d3",
  null
  
)

export default component.exports